<mat-button-toggle-group hideSingleSelectionIndicator class="view-toggle" [value]="value()" [disabled]="disabled()" (change)="onChange($event.value)">
  @for (option of options(); track option.value) {
    <span [matTooltip]="option.disabled ? (option.disabledTooltip ?? '') : ''">
      <mat-button-toggle class="segmented-toggle-button" [value]="option.value" [disabled]="disabled() || !!option.disabled">
        {{ option.label }}
        @if (option.showDot) {
          <span class="segmented-toggle-dot"></span>
        }
      </mat-button-toggle>
    </span>
  }
</mat-button-toggle-group>
